import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '13.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: 'navy',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: 5,
    border: '1px solid black',
    marginTop: 10,
    backgroundColor: 'navy',
    color: 'white'
  },
  columnHeader: {
    width: 'auto'
  },
  columnText: {
    width: '10%',
    textAlign: 'center'
  },
  columnTextWide: {
    width: '17%',
    textAlign: 'center'
  },
  columnTextNarrow: {
    width: '5%',
    textAlign: 'center'
  }
});

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IpdRequisitionPdf = ({ data }) => {
  console.log(data);
  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Ipd Requisition`}>
        <Page size="A4" style={styles.page}>
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text content="IPD Requisition" style={{ fontSize: '12px', margin: '0 auto' }} />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID NO.                 :" style={styles.textBold} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="OPD Date/Time       :" />
                <Text content={`${dateFormatter(data.dateTime)}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address                   :" />
                <Text content={`${data.address}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Patient Name      : " />
                <Text content={`${data.patientName}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex              :" />
                <Text content={`${data.age} / ${data.gender}`} />
              </View>
              <View style={styles.row}>
                <Text content="Mobile                 :" />
                <Text content={`${data.mobile}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Department            :" />
                <Text content={`${data.department}`} />
              </View>
              <View style={styles.row}>
                <Text content="Sponsor                  :" />
                <Text content={`${data.sponsor}`} />
              </View>
              <View style={styles.row}>
                <Text content="Operating Doctor    : " />
                <Text content={`${data.doctor}`} />
              </View>
            </View>
          </View>
          <Text
            content="Vitals"
            style={{ marginTop: '10px', fontSize: '12px', borderBottom: '1px solid black', width: '25%' }}
          />
          {data.vital.bp_sys !== '-' && (
            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text content="BP Sys                        -      " />
              <Text content={`${data.vital.bp_sys} `} />
            </View>
          )}
          {data.vital.diastol !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Diastol                       -      " />
              <Text content={`${data.vital.diastol} `} />
            </View>
          )}
          {data.vital.abdomen !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Abdomen                    -     " />
              <Text content={`${data.vital?.abdomen}`} />
            </View>
          )}
          {data.vital.pulse !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Pulse                          -     " />
              <Text content={`${data.vital?.pulse}`} />
            </View>
          )}
          {data.vital.dm !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="DM                             -      " />
              <Text content={`${data.vital?.dm}`} />
            </View>
          )}
          {data.vital.asthma !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Asthma                      -      " />
              <Text content={`${data.vital?.asthma}`} />
            </View>
          )}
          {data.vital.ihd !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="IHD                            -     " />
              <Text content={`${data.vital?.ihd}`} />
            </View>
          )}
          {data.vital.con_level !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Con Level                  -      " />
              <Text content={`${data.vital?.con_level}`} />
            </View>
          )}
          {data.vital.ihd !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Temp                        -    " />
              <Text content={`${data.vital?.ihd}`} />
            </View>
          )}
          {data.vital.weight !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Weight                      -     " />
              <Text content={`${data.vital?.weight}`} />
            </View>
          )}
          {data.vital.resp_rate !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Resp Rate               -      " />
              <Text content={`${data.vital?.resp_rate}`} />
            </View>
          )}
          {data.vital.chest !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Chest                      -      " />
              <Text content={`${data.vital?.chest}`} />
            </View>
          )}
          {data.vital.cvs !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="CVS                         -      " />
              <Text content={`${data.vital?.cvs}`} />
            </View>
          )}
          {data.vital.dre !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Dre                          -      " />
              <Text content={`${data.vital?.dre}`} />
            </View>
          )}
          {data.vital.cns !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Cns                         -      " />
              <Text content={`${data.vital?.cns}`} />
            </View>
          )}
          {data.vital.any_other !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Any Other                -      " />
              <Text content={`${data.vital?.any_other}`} />
            </View>
          )}
          {data.vital.allergies !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Allergies                  -      " />
              <Text content={`${data.vital?.allergies}`} />
            </View>
          )}
          {data.vital.height !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Height                     -      " />
              <Text content={`${data.vital?.height}`} />
            </View>
          )}
          {data.vital.blood_group !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Blood Group            -    " />
              <Text content={`${data.vital?.blood_group}`} />
            </View>
          )}
          {data.vital.pallor !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Pallor                       -    " />
              <Text content={`${data.vital?.pallor}`} />
            </View>
          )}
          {data.vital.icterus !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Icterus                     -    " />
              <Text content={`${data.vital?.icterus}`} />
            </View>
          )}
          {data.vital.clubbing !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Clubbing                  -   " />
              <Text content={`${data.vital?.clubbing}`} />
            </View>
          )}
          {data.vital.cyanos !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Cyanos                    -   " />
              <Text content={`${data.vital?.cyanos}`} />
            </View>
          )}
          {data.vital.jvp !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="JVP                        -   " />
              <Text content={`${data.vital?.jvp}`} />
            </View>
          )}
          {data.vital.lymphade !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Lymphade               - " />
              <Text content={`${data.vital?.lymphade}`} />
            </View>
          )}
          {data.vital.hydration !== '-' && (
            <View style={{ ...styles.row }}>
              <Text content="Hydration               - " />
              <Text content={`${data.vital?.hydration}`} />
            </View>
          )}
          <View style={styles.headerContainer}>
            <Text content="S. No." style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Complaints" style={{ ...styles.columnText, width: '40%' }} />
            <Text content="Duration" style={{ ...styles.columnText, width: '40%' }} />
          </View>
          {data.complaints &&
            data.complaints.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 5,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.complaint || '-'} style={{ ...styles.columnText, width: '40%' }} />
                <Text content={item.duration || '-'} style={{ ...styles.columnText, width: '40%' }} />
              </View>
            ))}
          <View style={styles.headerContainer}>
            <Text content="S. No." style={{ ...styles.columnText, width: '50%' }} />
            <Text content="Diagnos" style={{ ...styles.columnText, width: '50%' }} />
          </View>
          {data.diagnoses &&
            data.diagnoses.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 5,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnText, width: '50%' }} />
                <Text content={item.add_diagnos || '-'} style={{ ...styles.columnText, width: '50%' }} />
              </View>
            ))}
          <View style={styles.headerContainer}>
            <Text content="S. No." style={styles.columnTextNarrow} />
            <Text content="Type" style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Doctor" style={styles.columnTextWide} />
            <Text content="Service Name " style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Qty" style={styles.columnText} />
            <Text content="Rate" style={styles.columnText} />
            <Text content="Amount" style={styles.columnText} />
            <Text content="Net Amt" style={styles.columnText} />
          </View>
          {data.service_items &&
            data.service_items.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 5,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnTextNarrow }} />
                <Text content={item.type || '-'} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.doctor || '-'} style={{ ...styles.columnText, width: '22%' }} />
                <Text content={item.service_name || '-'} style={styles.columnText} />
                <Text content={item.quantity || '-'} style={styles.columnText} />
                <Text content={item.rate || '-'} style={{ ...styles.columnText }} />
                <Text content={item.amount || '-'} style={{ ...styles.columnText }} />
                <Text content={item.net_amt || '0'} style={{ ...styles.columnText }} />
              </View>
            ))}

          <View style={{ ...styles.headerContainer, marginTop: '5%' }}>
            <Text content="S. No." style={{ ...styles.columnTextNarrow, width: '10%' }} />
            <Text content="Medicine Name" style={{ ...styles.columnText, width: '20%' }} />
            <Text content="Unit" style={{ ...styles.columnTextWide, width: '10%' }} />
            <Text content="Qty" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Frequency" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Days" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Morning" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Noon" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Evening" style={{ ...styles.columnText, width: '10%' }} />
            <Text content="Night" style={{ ...styles.columnText, width: '10%' }} />
          </View>
          {data.medicines &&
            data.medicines.map((item, index) => (
              <View
                style={{
                  ...styles.row,
                  backgroundColor: index % 2 !== 0 ? '#ffffff' : '#f7f7f7',
                  marginTop: 5,
                  padding: '5px'
                }}
                key={index}
              >
                <Text content={index + 1} style={{ ...styles.columnTextNarrow, width: '10%' }} />
                <Text content={item.name || '-'} style={{ ...styles.columnText, width: '20%' }} />
                <Text content={item.unit || '-'} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.quantity || '-'} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.frequency || '-'} style={{ ...styles.columnText, width: '10%' }} />
                <Text content={item.days || '0'} style={{ ...styles.columnText, width: '10%' }} />
                <Text
                  content={item.morning === true ? 'YES' : '' || ''}
                  style={{ ...styles.columnText, width: '10%' }}
                />
                <Text content={item.noon === true ? 'YES' : '' || ''} style={{ ...styles.columnText, width: '10%' }} />
                <Text
                  content={item.evening === true ? 'YES' : '' || ''}
                  style={{ ...styles.columnText, width: '10%' }}
                />
                <Text content={item.night === true ? 'YES' : '' || ''} style={{ ...styles.columnText, width: '10%' }} />
              </View>
            ))}
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Follow Up Date             :     " style={styles.textBold} />
                <Text content={`${data.follow_up_date || ''}`} />
              </View>
              <View style={styles.row}>
                <Text content="Follow Up Days            :    " />
                <Text content={`${data?.follow_up_days || ''} Days`} />
              </View>
              <View style={{ ...styles.row, width: '70%' }}>
                <Text content="Advice                          :   " />
                <Text content={`${data?.advice || ''}`} />
              </View>
              <View style={styles.row}>
                <Text content="Remarks                      :   " />
                <Text content={`${data?.remarks || ''}`} />
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
